import { styled, Box, IconButton } from '@mui/material';

export const NotificationContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFF8E1',
  borderRadius: '12px',
  padding: '16px 20px',
  marginBottom: '24px',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  position: 'relative',
}));

export const ContentContainer = styled(Box)(() => ({
  flex: 1,
  alignItems: 'center',
  gap: 15,
  display: 'flex',

  '& .title': {
    fontWeight: 700,
    fontSize: 14,
    color: '#000000',
    marginBottom: '4px',
  },
  '& .description': {
    fontWeight: 500,
    fontSize: 13,
    color: '#212121',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '8px',
  right: '8px',
  backgroundColor: 'orange',
  color: 'white',
  width: '24px',
  height: '24px',
  fontSize: '12px',
  fontWeight: 'bold',

  '&:hover': {
    backgroundColor: 'darkOrange',
  },
}));
